import { alpha, type Theme } from '@mui/material/styles';

// The segmented control of the touch mockups: one border around the group and a
// 1 px rule between the buttons (not a border on every button, as MUI draws
// it). Use as `sx={[segmentedSx(6), { ... }]}` on a ToggleButtonGroup.

export const RULE = (theme: Theme) => alpha(theme.palette.text.primary, 0.2);

export const segmentedSx = (radius: number) =>
    ({
        border: '1px solid',
        borderColor: RULE,
        borderRadius: `${radius}px`,
        overflow: 'hidden',
        '& .MuiToggleButton-root': {
            border: 0,
            borderRadius: 0,
            ml: 0,
            '&.Mui-disabled': { border: 0 },
            '&:not(:first-of-type), &.Mui-disabled:not(:first-of-type)': {
                ml: 0,
                borderLeft: '1px solid',
                borderLeftColor: RULE,
            },
        },
    }) as const;
